namespace BRW
{
	export class List
		extends ui.tab.TabHTMLPresentation
	{
		private MList: SPA.gui.Listing<Wollmilch.MP01.IObject>;
		private MData: Wollmilch.MP01.IObject[][];

		public constructor()
		{
			super();

			this.MData = new Array();

			this.MList = new SPA.gui.Listing<Wollmilch.MP01.IObject>(
				new SPA.BRW.data.BRWTableDataModel(
				{
					header: true,
					headerEnd: true,
					style:
					{
						condense: true,
						hover: true,
						stripes: true,
					},
				},
				),
				15,
				( list: SPA.gui.Listing<Wollmilch.MP01.IObject>, count: number, page: number ): void =>
				{
					count = clamp( count, 5, 50 );

					const idx = this.MData.findIndex( ( value, index ) =>
					{
						return index === page && value !== undefined;
					},
					);

					if ( idx > -1 )
					{
						list.Content().Data( this.MData[ idx ] );
						list.Content().rebuild();

						return;
					}

					new Wollmilch.AJAX(
						{
							on:
							{
								success: ( text: string ): void =>
								{
									let obj = null;
									try
									{
										obj = Wollmilch.jsonize( text );
									}
									catch ( e )
									{
										app.addNotify(
											{
												body: [ ui.text( app.getMessage( 'BRW.GENERAL.ERROR.no_data' ) ) ],
												context: 'warning',
												timeout: Number(app.getConfigValue("ToastTimeout")),
												title: [ ui.h( 3, app.getMessage( 'BRW.GENERAL.ERROR.title' ) ) ],
											},
										);

										return;
									}

									if ( !obj || !obj.success )
									{
										app.addNotify(
											{
												body: [ ui.text( app.getMessage( 'BRW.GENERAL.ERROR.no_data' ) ) ],
												context: 'info',
												timeout: Number(app.getConfigValue("ToastTimeout")),
												title: [ ui.h( 3, app.getMessage( 'BRW.GENERAL.ERROR.title' ) ) ],
											},
										);

										return;
									}

									list.Content().Data( obj.data );
									list.Content().rebuild();

									list.SetPage( page, obj.count );

									this.MData[ page ] = obj.data;
								},
							},
							url: 'MP01/list/' + app.getAuthenticationManager().getPerson() + '/limit/' + count + '/page/' + page,
						},
						Wollmilch.AJAXCallbase_e.BRW,
					).send();

				},
			);
		}

		public rebuild( root: JQuery|ui.base.BaseHTMLElement ): List
		{
			super.rebuild( root );

			this.empty();

			this.MList.rebuild( new ui.Box.Box().appendTo( this ) );

			if ( this.m_Entry ) { this.m_Entry.DeactivateReloadSpin(); }

			return this;
		}

	}
}
